import React from "react";
import S from "./ContactInfoForm.style";
import { nlToBr } from "@/src/helpers";
import ContactComponent from "@/components/ContactComponent/ContactComponent";
import Title from "@/components/Title/Title";
import { Wysiwyg } from "@/styles/typography";

export interface Props {
  backgroundColor: string;
  leftSide: {
    address: string;
    addressTitle: string;
    infoEmail: string;
    infoTel: string;
    infoTitle: string;
    locationText: string;
    locationTitle: string;
  };
  rightSide: {
    title: string;
  };
}

const ContactInfoForm: React.FC<Props> = (data) => {
  const { backgroundColor, leftSide, rightSide } = data;

  const setBackgroundColor = () => {
    if (backgroundColor === "white") {
      return "#f9f9f9";
    } else if (backgroundColor === "blue") {
      return "#224C5D";
    }
    return "#2F5A50";
  };

  const setFontColor = () => {
    if (backgroundColor === "white") {
      return "#224C5D";
    } else {
      return "#f9f9f9";
    }
  };

  return (
    <div className="main-inner">
      <S.Container backgroundColor={setBackgroundColor()}>
        <S.SideContainer>
          <S.InfoContainer>
            <Title
              title={leftSide.addressTitle}
              backgroundColor={backgroundColor}
              fontSize="h3"
            />
            <S.H5Title color={setFontColor()}>
              {nlToBr(leftSide.address)}
            </S.H5Title>
          </S.InfoContainer>
          <S.InfoContainer>
            <Title
              title={leftSide.infoTitle}
              backgroundColor={backgroundColor}
              fontSize="h3"
            />
            {leftSide.infoTel && (
              <S.ContactLink
                color={setFontColor()}
                href={`tel:${leftSide.infoTel}`}
              >
                TEL: {leftSide.infoTel}
              </S.ContactLink>
            )}
            {leftSide.infoEmail && (
              <S.ContactLink
                color={setFontColor()}
                href={`mailto:${leftSide.infoEmail}`}
              >
                MAIL: {leftSide.infoEmail}
              </S.ContactLink>
            )}
          </S.InfoContainer>
          <S.InfoContainer>
            {leftSide.locationTitle && (
              <Title
                title={leftSide.locationTitle}
                backgroundColor={backgroundColor}
                fontSize="h3"
              />
            )}
            {leftSide.locationText && (
              <Wysiwyg
                color={setFontColor()}
                dangerouslySetInnerHTML={{
                  __html: leftSide.locationText,
                }}
              />
            )}
          </S.InfoContainer>
        </S.SideContainer>
        <S.SideContainer>
          {rightSide.title && (
            <Title
              title={rightSide.title}
              fontSize="h2"
              backgroundColor={backgroundColor}
            />
          )}

          <S.FormContainer>
            <ContactComponent backgroundColor={backgroundColor} />
          </S.FormContainer>
        </S.SideContainer>
      </S.Container>
    </div>
  );
};

export default ContactInfoForm;
